var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKustomerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 99,
    viewBox: "0 0 103 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_529)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_529",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 104,
    height: 99
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.001 0H0.000671387V98.1884H103.001V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9281 98.1884C8.86217 98.1884 0.000671387 78.4901 0.000671387 49.2239C0.000671387 19.9577 8.45388 0 51.9281 0C95.4029 0 103.006 20.1398 103.006 49.5881C103.006 79.0365 94.9945 98.1884 51.9281 98.1884Z",
    fill: "#FBEC2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4097 71.1291C41.5164 71.1291 33.4715 62.8639 33.4715 52.7055V42.6135H37.8857V52.7055C37.8857 60.4305 43.9552 66.7151 51.4097 66.7151C58.8641 66.7151 64.9339 60.4305 64.9339 52.7055V42.6135H69.348V52.7055C69.348 62.8639 61.3032 71.1291 51.4097 71.1291Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.886 33.636C45.1246 31.7268 43.3037 30.4963 41.2511 30.4963C39.1985 30.4963 37.3832 31.7323 36.6162 33.636L32.7759 32.0965C34.1718 28.6093 37.499 26.3525 41.2511 26.3525C45.0032 26.3525 48.3304 28.6038 49.7264 32.0965L45.886 33.636Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0037 33.636C65.2369 31.7268 63.4215 30.4963 61.3692 30.4963C59.3164 30.4963 57.501 31.7323 56.7342 33.636L52.8939 32.0965C54.2895 28.6093 57.6169 26.3525 61.3692 26.3525C65.121 26.3525 68.4484 28.6038 69.8441 32.0965L66.0037 33.636Z",
    fill: "#292929"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 98.365,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKustomerLogo);
export default __webpack_public_path__ + "static/media/kustomer-logo.f454486d5cf1dad2691a8e327e57299c.svg";
export { ForwardRef as ReactComponent };